module.exports = "/images/training_thumb.png?27ce8a7387dafffba8e5c8d03afb6550";